import { useGlobalContext } from '@/context/Global/GlobalContext';
import { requestAdminLoginApiV2 } from '@/data/api/request/loginRequests';
import { useMutation } from '@tanstack/react-query';

const useAdminSignIn = () => {
  const { setAdminSession } = useGlobalContext();

  const { mutate: login, isPending: isLoginLoading } = useMutation({
    mutationFn: async (body: { email: string; password: string }) => {
      const loginApiV2Result = await requestAdminLoginApiV2(body);
      const loginV2Token = loginApiV2Result.token;
      if (!loginV2Token) throw Error('Invalid ApiV2 Token');
      setAdminSession?.({
        apiV2Token: loginV2Token,
        name: loginApiV2Result.name,
        lastName: loginApiV2Result.last_name,
      });

      return { userId: loginApiV2Result.user_id };
    },
  });

  return {
    login,
    isLoginLoading,
  };
};

export default useAdminSignIn;
